import { DocumentMinimalDto, FileTypeEnum } from "api/documents"
import { CardsSection } from "components/layout/Section/CardsSection"
import { SectionOutlet } from "components/layout/Section/SectionOutlet"
import { NsKey } from "enums/NsKey"
import { useDynamicTranslation } from "hooks/useDynamicTranslation"
import { DownloadIcon } from "lucide-react"
import { FC, useCallback, useEffect, useState } from "react"
import { downloadDocumentByStoredId } from "services/documentsAPI"
import { documentsAPI } from "services/swagger-api"

interface ContractInsuranceClaimProps {
  contractId: string
}

export const ContractInsuranceClaim: FC<ContractInsuranceClaimProps> = ({ contractId }) => {
  const { t } = useDynamicTranslation([NsKey.Contract])
  const [claimDocument, setClaimDocument] = useState<DocumentMinimalDto>()
  const onDownloadGuide = useCallback(async () => {
    if (claimDocument && claimDocument.storedFileId) {
      const res = await downloadDocumentByStoredId(claimDocument.storedFileId);
      const blob = new Blob([res], { type: `application/pdf` });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    }
  }, [claimDocument])

  useEffect(() => {
    const getClaimDocument = async () => {
      try {
        const response = await documentsAPI.getContractDocumentByFileType({ contractId, fileType: FileTypeEnum.AttestationSinistre })
        if (response)
          setClaimDocument(response)
      } catch (error) {
        // Document optionnel : absent = 204 sans corps, que le client généré
        // échoue à parser (SyntaxError) — le bouton de téléchargement est
        // simplement masqué.
        if (!(error instanceof SyntaxError)) console.error(error)
      }
    }
    getClaimDocument()
  }, [contractId])

  return (
    <SectionOutlet title={t('CONTRACT.LABELS.CLAIM_REPORT')}>
      <CardsSection title={t('CONTRACT.LABELS.TO_CLAIM_A_REPORT')}>
        <div className="prose prose-gray max-w-none">
          <p className="text-gray-700 leading-relaxed mb-4">
            Vous trouverez ci-joint un document afin de vous présenter de manière claire et concise
            les démarches à suivre pour déclarer un sinistre de votre client auprès de la compagnie d'assurance.
          </p>

          <p className="text-gray-700 leading-relaxed mb-4">
            Vous y trouverez toutes les étapes nécessaires pour assurer une gestion rapide et efficace
            du sinistre, ainsi que les documents et informations à fournir par l'assuré.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            Ce guide a été conçu pour vous accompagner dans cette procédure et vous permettre de
            répondre au mieux aux besoins de vos clients.
          </p>

          {claimDocument?.storedFileId && (
            <div className="mb-6">
              <button
                onClick={onDownloadGuide}
                className="inline-flex items-center gap-2 text-primary/80 hover:text-primary font-medium transition-colors duration-200 hover:underline"
              >
                <span>Télécharger la liste des pièces à fournir</span>
                <DownloadIcon className="w-4 h-4" />
              </button>
            </div>
          )}

          <p className="text-sm text-gray-600 italic">
            Restant à votre disposition pour toute question ou information complémentaire.
          </p>
        </div>
      </CardsSection>
      {/* <div className="flex justify-center pt-4"> */}
      {/*   <Button color="secondary">{t('CONTRACT.LABELS.TO_REPORT_A_CLAIM')}</Button> */}
      {/* </div> */}
    </SectionOutlet>
  )
}
